/**
 * @generated SignedSource<<07a668f0fb98e0e0402c06c0abdd4fcd>>
 * @relayHash c557ac30826b822ad2965f1312f13b1f
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/441.0.0-2023-12-07T14:38:11.118Z/shippingDetailsLocationAddPartialAddressMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type addPartialShippingAddressInput = {
  address: AddressInput;
  clientMutationId?: string | null;
  userId: string;
};
export type AddressInput = {
  active?: boolean | null;
  addressBookMember?: boolean | null;
  city?: string | null;
  company?: string | null;
  contact?: string | null;
  country?: string | null;
  firstName?: string | null;
  label?: string | null;
  lastName?: string | null;
  line1?: string | null;
  line2?: string | null;
  phoneNumber?: string | null;
  state?: string | null;
  zipCode?: string | null;
};
export type shippingDetailsLocationAddPartialAddressMutation$variables = {
  input: addPartialShippingAddressInput;
};
export type shippingDetailsLocationAddPartialAddressMutation$data = {
  readonly addPartialShippingAddress: {
    readonly address: {
      readonly country: string | null;
      readonly serviceId: string | null;
      readonly zipCode: string | null;
    } | null;
  } | null;
};
export type shippingDetailsLocationAddPartialAddressMutation = {
  response: shippingDetailsLocationAddPartialAddressMutation$data;
  variables: shippingDetailsLocationAddPartialAddressMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zipCode",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "shippingDetailsLocationAddPartialAddressMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "addPartialShippingAddressPayload",
        "kind": "LinkedField",
        "name": "addPartialShippingAddress",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Address",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "shippingDetailsLocationAddPartialAddressMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "addPartialShippingAddressPayload",
        "kind": "LinkedField",
        "name": "addPartialShippingAddress",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Address",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/441.0.0-2023-12-07T14:38:11.118Z/shippingDetailsLocationAddPartialAddressMutation",
    "metadata": {},
    "name": "shippingDetailsLocationAddPartialAddressMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "562c84ee7b771e7b44466d8779a35725";

export default node;
